import { AbstractControl, ValidatorFn, ValidationErrors} from '@angular/forms';

export function specialCharacterValidator(): ValidatorFn {
    return (control: AbstractControl) => {
        const hasSpecialChar = /[!@#$%^&*]/.test(control.value); // Modify regex for desired special chars
        return hasSpecialChar ? null : {hasSpecialChar: true};
    };
}


export function lowercaseCharacterValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const hasLowercase = /[a-z]/.test(control.value);
        return hasLowercase ? null : { hasLowercase: true };
    };
}

export function numberCharacterValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const hasNumber = /[0-9]/.test(control.value);
        return hasNumber ? null : { hasNumber: true };
    };
}
